import { render } from "./giving-mode.vue?vue&type=template&id=ec28487a"
import script from "./giving-mode.vue?vue&type=script&lang=js"
export * from "./giving-mode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__